
import templateComponent from '@/app-template/lib/components/ImageSlides.vue';
import { defineComponent } from '@vue/runtime-core';

export default defineComponent({
  name: 'ImageSlides',
  components: { templateComponent },
});
